import { IApplicationState } from '../types/redux';

export function selectIsLoadingFeedback(state: IApplicationState) {
  return state.feedback.isLoading;
}

export function selectIsSendErrorFeedback(state: IApplicationState) {
  return state.feedback.isSendError;
}
